import type { ControllerPresentationProjection } from './gamepadMappingProfile';

export interface ControllerUIInputFrame {
  connected: boolean;
  timestamp: number;
  controller: ControllerPresentationProjection | null;
  left: boolean;
  right: boolean;
  up: boolean;
  down: boolean;
  confirmJustPressed: boolean;
  backJustPressed: boolean;
  menuJustPressed: boolean;
}

export interface ControllerUIRouteResult {
  captureGamepad: boolean;
  allowContextualQuestAction: boolean;
}

export type ControllerUIResetReason = 'blur' | 'clear' | 'disabled' | 'dispose';

export interface ControllerUIInputHandler {
  route(frame: ControllerUIInputFrame): ControllerUIRouteResult;
  reset(reason: ControllerUIResetReason): void;
}

const NOT_CAPTURED: ControllerUIRouteResult = Object.freeze({
  captureGamepad: false,
  allowContextualQuestAction: false,
});

let handler: ControllerUIInputHandler | null = null;

/** Synchronous local seam between the game-loop poller and the one UI owner. */
export const controllerUIInputBridge = {
  connect(next: ControllerUIInputHandler): () => void {
    handler = next;
    return () => {
      if (handler === next) handler = null;
    };
  },

  route(frame: ControllerUIInputFrame): ControllerUIRouteResult {
    if (!handler) return NOT_CAPTURED;
    try {
      return handler.route(frame);
    } catch {
      return { captureGamepad: true, allowContextualQuestAction: false };
    }
  },

  reset(reason: ControllerUIResetReason): void {
    handler?.reset(reason);
  },
};

export function resetControllerUIInputBridgeForTests(): void {
  handler = null;
}
